module.exports = __webpack_public_path__ + "img/account-creation-success.5eb6c438.svg";